const config = {
	// Same-origin so a phone on the LAN hits this webpack server, which
	// proxies /api to the Go backend (see package.json "proxy").
	API_URL: '/api/',
};

export default config;